<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Picking Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="grid">List</vs-button>
      <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="print"
          color="#5b3cc4"
          v-if="btndis"
        >Print</vs-button>
        <!-- <a href="#">Hola mundo</a> -->

        <vs-dropdown-menu>
          <vs-dropdown-item @click="goPrint">PickOrder</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <p class="pr-4"></p>
      <vs-button color="success" type="filled" icon="list" @click="goDetail" v-if="btndis">Detail</vs-button>
      <p class="pr-4"></p>

    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <pickadd v-if="addshow" :key="addshow" :acstate="acstate" :recid="recid" @grid="grid"></pickadd>
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        @mousedown.middle.native="getXY"
      ></aggrid>
    </transition-group>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid";
import pickadd from "./pickadd";

import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      addshow: false,
      gridshow: false,
      btndis: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goPrint", label: "Print" },
        { act: "goDetail", label: "PickDetail" },
        { act: "hideFab", label: "Hide" }
      ]
    };
  },
  computed: {
    fabStyle: function() {
      return {
        left: this.curX + "px",
        top: this.curY + "px"
      };
    }
  },
  methods: {
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val) {
      this.btndis = true;
      this.recid = val;
    },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "ADD";
    },
    grid() {
      this.addshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    goDetail() {
      this.btndis = true;
      this.$router.replace("/pickdetails/" + this.recid);
    },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    getArray(data) {
      // console.log(data);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.exbordersNumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbordersnumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbitemnum,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbdetailsSkuscode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.edescription,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text:
              this.formatnumber(item.itempck) +
              "/" +
              this.formatnumber(item.totalpck),
            fontSize: 10,
            bold: false,
            alignment: "right",
          },
          {
            text: item.packagesCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.locationsCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: this.cvDate(item.createdAt),
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.tmotypesCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
        ]);

        i++;
        // console.log(i);
      });
    },
 async goPrint() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        this.loading = true;

        if (token) {
          const formData = {
            companyGroupsCode: this.companyGroupsCode,
            number: this.recid,
            editor: this.userid
            // from: '2022-01-11'
          };
          // const response = await axios.post(`${BASE_API_URL}/agents/findall`, formData);

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/picks/picksPrint`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            // console.log(response.data);

            this.getArray(response.data.pickDetails);

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "landscape",
              footer: (currentPage, pageCount) => {
                return {
                  columns: [
                    {
                      text: [
                        {
                          text:
                            "ผู้จัดทำเอกสาร " +
                            response.data.pickDetails[0].editor +
                            "\t\t\t\t\t\t\t",
                          fontSize: 14,
                        },

                        {
                          text:
                            "ผู้ส่งมอบ______________________" +
                            "\t\t\t\t\t\t\t",
                          fontSize: 14,
                        },
                        {
                          text:
                            "ผู้รับมอบ______________________" +
                            "\t\t\t\t\t\t\t",
                          fontSize: 14,
                        },
                        {
                          text:
                            "พิมพ์ ณ วันที่ " + this.cvDate(new Date()) + "\n",
                          fontSize: 14,
                        },
                        {
                          text:
                            "Page " +
                            currentPage.toString() +
                            " / " +
                            pageCount +
                            "\t\t",
                        },
                      ],
                      alignment: "center",
                    },
                  ],
                };
              },

              content: [
                {
                  text: "ใบสั่งการนำสินค้าออกจากคลังสินค้า",
                  style: "title",
                  // [left, top, right, bottom]
                  margin: [0, -20, 0, 0],
                },
                {
                  text: "ใบนำสินค้าออกเลขที่ " + response.data.picksNumber,
                  style: "subtitle",
                  margin: [0, 0, 0, 10],
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [30, 50, 60, 30, 120, 140, 45, 35, 60,60,60], // 525(portrait) 700(landscape)
                    body: [
                      [
                        {
                          text: "ลำดับ",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Outbound Number",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Number",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Item",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Product Code",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Description",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Package",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "UNIT",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Location",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Order Pick At",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Type",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 50, 60, 30, 120, 140, 45, 35, 60,60,60], // 525(portrait) 700(landscape)
                    // body: this.getArray(res.data.message),
                    body: this.arData,
                    // body: [[{}, {},{}, {}, {}, {},{}, {}, {}]],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 50, 60, 30, 120, 140, 45, 35, 60,60,60], // 525(portrait) 700(landscape)
                    body: [
                      [
                        {},
                        {},
                        {},
                        {},
                        {},
                        {
                          text: "Total Packages",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: this.formatnumber(response.data.sumpck),
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {},
                        {},
                        {},
                        {},
                      ],
                    ],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 18,
                  bold: true,
                  alignment: "center",
                },
                subtitle: {
                  fontSize: 16,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    cusEdit() {
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "EDIT";
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert
      });
    },
     async acceptAlert() {
      this.btndis = false;
      this.btndis3 = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/picks/delete`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(responseponse.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  components: {
    aggrid,
    pickadd
  },
   created() {
    this.checkProfiles();
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
